

import axiosInstance from './apis';


export const getCustomersBalance = async(customerId) =>{
  return await axiosInstance.post(`/accounts/get-sundry-debitor-balance`,{
    customerId: customerId,
  })
}


export const getTagOnEdit = async (payload) => {
  return await axiosInstance.post(`/settings/get-tag-on-edit`, payload);
  
};